import { compose, withHandlers, withState } from 'recompose';
import AutoPayoutDeclinedFeedbackModal from './AutoPayoutDeclinedFeedbackModal';
import { declineAutoPayoutSuggestion } from './actions';

export default compose(
  withState('feedback', 'setFeedback', ''),
  withHandlers({
    declineAndSendFeedback: props => (feedback) => {
      const trimmedFeedback = feedback ? feedback.trim() : '';
      declineAutoPayoutSuggestion(props.shopId, trimmedFeedback !== '' ? trimmedFeedback : null);
      props.onCloseFollowUpModalHandler();
    },
  }),
  withHandlers({
    onSubmitDeclineFeedbackHandler: props => () => {
      props.declineAndSendFeedback(props.feedback);
    },
    onCloseClickedHandler: props => () => {
      props.declineAndSendFeedback('');
    },
  })
)(AutoPayoutDeclinedFeedbackModal);
